<template>
  <div class="insurance">
    <!-- <div class="ceshi">
      <z-select
      :option='msgs'
      indexs='ids'
      values='value1'
      v-model="test1" 
      @ChangeOk='names'/>
    </div>
    <div class="ceshi">
      <z-select
      :option='msgs'
      indexs='ids'
      values='value1'
      v-model="test2" 
      @ChangeOk='names'/>
    </div> -->
    <div class="buged">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(i,index) in bannerImg" :key='index'>
            <img :src="i" class="swiperImg">
        </swiper-slide>
      </swiper>
    </div>
    <div class="insuranceCon1" id="insuranceCon1">
      <div class="insuranceCon11 contentWidth">
        <div class="insuranceCon11_left">
          <img src="../../assets/img/index/sb.png" alt="">
          <div class="insuranceAbout">
            <span class="insuranceAbout_top">
              ABOUT US
            </span><br>
            <span class="insuranceAbout_bot">
              关于数聚智连
            </span>
          </div>
        </div>
        <div class="insuranceCon11_right">
          <span></span>
          <p>
            <span>北京数聚智连科技股份有限公司是一家以效果营销驱动销售的整合型品牌运营公司，致力于帮助国内外品牌在中国市场实现品牌爆发。数聚智连总部位于北京，在中国上海、广州、杭州等设有分支机构和香港子公司。公司获得ISO9001质量管理体系和ISO27001信息安全管理体系双认证。</span>
            
            <div>
              <img style="margin-top: 10px; width: 65px;" src="../../assets/img/index/ISO9001.jpg" alt="">
              <img style="margin-top: 10px;margin-left: 20px; width: 65px;" src="../../assets/img/index/ISO27001.jpg" alt="">
            </div>
          </p>
        </div>
      </div>
      <div class="insuranceCon12 contentWidth">
        <div class="insuranceCon12To" @mouseover='ImgMouse(0)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==0?'1':'0')">
            <span :class="ImgHover==0?'ZhuanN':'ZhuanY'"></span>
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<3?'ImgBig':'ImgMix'" src="../../assets/img/index/bk1.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(1)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==1?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<3?'ImgBig':'ImgMix'" src="../../assets/img/index/bk2.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(2)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==2?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<3?'ImgBig':'ImgMix'" src="../../assets/img/index/bk3.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(3)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==3?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==3" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<5?'ImgBig':'ImgMix'" src="../../assets/img/index/bk4.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(4)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==4?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<5?'ImgBig':'ImgMix'" src="../../assets/img/index/bk5.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(5)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==5?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<5?'ImgBig':'ImgMix'" src="../../assets/img/index/bk6.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="insuranceCon2" id='insuranceCon2' :style="'background-size:'+(100+Con2*5)+'% 100%'">
      <div class="insuranceCon21 contentWidth">
        <div class="insuranceH1" :style="'opacity:'+(Con2==0?'0':'1')">
          <span class="InsHistory1">
            HISTORY
          </span><br>
          <span class="InsHistory2">
            数聚智连发展史
          </span>
          <span class="InsHistory3">

          </span>
        </div>
        <div class="insuranceSJZ">
          <span class="insuranceLine" :style="'width:'+(Con2<6?Con2*14.27:100)+'%'">
          </span>
          <span class="insuranceDot" :style="'left:'+(i)*14.27+'%;'+'opacity:'+(Con2+1<=i?'0':'1')" v-for="i in 6">
          </span>
          <div 
          class="insuranceTitle" 
          v-for="(i,index) in Con2Text" 
          :style="'left:'+(index+1)*14.27+'%;'+'height:'+(Con2<=index?'0px;':'150px;')+'top:'+(index%2!=1?'-120px;':'50px;')">
            <span class="InsuTitle">{{i.title}}</span><br>
            <h2 v-for="(j,item) in i.h">{{i.h[item]}}</h2><br>
            <span class="InsuCon">{{i.s}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 主体公司介绍 -->

    
    <div class="zhutijieshao" id="zhutijieshao">
      <div class="zhutijieshao contentWidth">
        <div class="receivingPrizes" :style="'opacity:'+(Con4==0?'0':'1')" data-aos=""  data-aos-duration="1200">
          <span class="receivingPrizes1">
            MAIN COMPANIES
          </span><br>
          <span class="receivingPrizes2">
            主体公司介绍
          </span>
          <span class="receivingPrizes3" >
          </span>
        </div>

        <div class="zhutiSend">
          <div v-for="i in zhuti">
            <img :src="i.img" style="margin-bottom:10px;"/>
            <h3>{{i.name}}</h3>
            <span>{{i.content}}</span>
          </div>
        </div>
      </div>

      
    </div>

    <!-- 主体公司介绍结束 -->
    <div class="insuranceCon3" id="insuranceCon3">
      <div class="insuranceCon31 contentWidth">
        <div class="receivingPrizes" :style="'opacity:'+(Con3==0?'0':'1')" data-aos=""  data-aos-duration="1200">
          <span class="receivingPrizes1">
            RECEIVING PRIZES
          </span><br>
          <span class="receivingPrizes2">
            所获奖项
          </span>
          <span class="receivingPrizes3">

          </span>
        </div>
        <!-- <div class="insuranceCon32 contentWidth">
          <div class="con32KP" :style="'left:'+(40+110*(Con3)*0.25)+'px;top:'+0+'px;z-index:2;'">
            <div v-for="i in con32KP2" :style="'opacity:'+(Con3>1?'1':'0')">
              <span>{{i.title}}</span><br>
              <span>{{i.s}}</span>
            </div>
          </div>
          <div class="con32KP" :style="'left:'+(100+550*(Con3)*0.25)+'px;top:'+(-40+40*(Con3)*0.25)+'px;z-index:1;'">
            <div v-for="i in con32KP1" :style="'opacity:'+(Con3>2?'1':'0')">
              <span>{{i.title}}</span><br>
              <span>{{i.s}}</span>
            </div>
          </div>
        </div> -->


        <div class="insuranceCon32 contentWidth">
        
          <swiper :options="swiperOption2" ref="mySwipe1r2">
            <swiper-slide v-for="(i,index) in con32KP1" :key='index'>
              <div class="luoBI">
                <img :src="i.img">
                <span>{{i.title}}</span><br>
                <span style="font-size:12px;line-height:20px;color:#828282;" v-html="i.s"></span>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" style="left:-20px;"></div><!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        </div>


      </div>
      
    </div>
  </div>
</template>

<script>
import ZSelect from '../modules/Zselect'
export default {
  name: 'insurance',
  components:{ZSelect},
  data () {
    return {
      bannerImg:[
        // require('../../assets/img/index/banner1.jpg'),
        require('../../assets/img/index/banner2.jpg'),
        //临时的一张banner图 
        require('../../assets/img/index/banner3ls.jpg'),
        require('../../assets/img/index/banner5ls.jpg'),
        // require('../../assets/img/index/banner3.jpg'),
        // require('../../assets/img/index/banner5.jpg'),

        // require('../../assets/img/index/banner1111.png'),
        // require('../../assets/img/index/banner202001.png'),
        // require('../../assets/img/index/banner202002.png'),
        // require('../../assets/img/index/banner2019133.jpg'),
        // // require('../../assets/img/index/banner202003.png'),
        // require('../../assets/img/index/banner2019131.jpg'),
        // require('../../assets/img/index/banner1.jpg'),
        // require('../../assets/img/index/banner2.jpg'),
        // require('../../assets/img/index/banner3.jpg'),
        // require('../../assets/img/index/banner4.jpg'),
      ],
      zhuti:[
        {
          img:require('../../assets/img/index/sjds.png'),
          name:'数聚电商',
          content:'以营销驱动销售的端到端电商服务公司，倡导高效整合型电商服务理念，通过高效营销（电商媒体、电商营销等) 和高效运营驱动品牌销售。',
        },
        {
          img:require('../../assets/img/index/blwy.png'),
          name:'北联伟业',
          content:'淘宝天猫第一批淘拍档合作商，长期服务世界500强企业；从早期的电商代运营逐步扩展到全渠道经销、营销业务。业界资深行业专家。',
        },
        // {
        //   img:require('../../assets/img/index/dl.png'),
        //   name:'东连科技',
        //   content:'东连是数聚智连旗下专注京东平台业务的子公司，服务范围从店铺运营，视觉设计，内容运营等全运营，再到效果营销，无界零售等品牌营销领域，目前在京东服务品牌数量20+，总GMV50亿以上。',
        // },
        // {
        //   img:require('../../assets/img/index/cys.png'),
        //   name:'畅益思',
        //   content:'专注零售市场服务，涵盖零售终端SI设计，店面设计和装修，POSM设计和制作，销售人员管理，终端活动策划及新零售场景营销。',
        // },
        {
          img:require('../../assets/img/index/bshy.png'),
          name:'博思瀚扬',
          content:'全新的新零售场景营销服务，通过对企业数据中台的建设，打通线上线下数据，充分利用新零售工具（品牌号，新零售营销工作台等SAAS功能），重新构建人货场，帮助企业打破传统零售店面的客流瓶颈，实现销售增长。',
        }
      ],
      test1:'1',
      test2:'1',
      msgs: [{
        ids:1,
        value1:'我是1'
      },{
        ids:2,
        value1:'我是2'
      },{
        ids:3,
        value1:'我是3'
      },{
        ids:4,
        value1:'我是4'
      },],
      swiperOption2:{
        // 一行显示slider的个数
        slidesPerView: 3,
      
          // 定义slides的数量多少为一组
        slidesPerGroup: 1,
        // navigation:{
        //   nextButton:'.swiper-button-next',//绑定下一页的控制按钮
        //   prevButton:'.swiper-button-prev',//绑定上一页的控制按钮,

        // },
        navigation: {

        nextEl: ".swiper-button-next", //前进按钮的css选择器或HTML元素。

        prevEl: ".swiper-button-prev", //后退按钮的css选择器或HTML元素。

        hideOnClick: true, //点击slide时显示/隐藏按钮

        disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。

        hiddenClass: "my-button-hidden" //按钮隐藏时的Class

        },

        loop:false,
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000
        },
        observer:true,
        speed:300,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      
      swiperOption:{
        loop:true,
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000
        },
        observer:true,
        speed:1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },

      Con2Text:[
        {
          title:'2007',
          h:['北联伟业成立','博思瀚扬成立'],
        },
        {
          title:'2010',
          h:['北联伟业成为阿里第一批TP'],
        },
        {
          title:'2012',
          h:['北联伟业成为阿里TP','KA服务商'],
        },
        {
          title:'2015',
          h:['新公司整合成立'],
        },
        {
          title:'2016',
          h:['挂牌新三板  '],
          // s:'（股票代码：300058）'
        },
        {
          title:'2018',
          h:['战略升级，更名为“北京数聚智连科技股份有限公司”，开启中国领先的品牌爆发引擎的服务理念'],
        },
      ],
      Con2:0,
      Con1:0,
      Con3:0,
      Con4:0,
      ImgHover:0,
      con32KP1:[
        {
          img:require('../../assets/img/index/202305.jpg'),
          title:'第14届金鼠标“数字营销最具创新精神品牌”奖',
        },
        {
          img:require('../../assets/img/index/202304.jpg'),
          title:'2022年度卓越代运营服务商“铁冬青”奖',
        },
        {
          img:require('../../assets/img/index/202303.jpg'),
          title:'m awards年度新品打爆增长奖',
        },
        {
          img:require('../../assets/img/index/202302.jpg'),
          title:'抖音电商品牌服务商认证',
        },
      
        {
          img:require('../../assets/img/index/202301.jpg'),
          title:'2022年度“京卓越”代运营服务商奖',
        },
      
        {
          img:require('../../assets/img/index/202217.jpg'),
          title:'2022年度大中华区艾菲效果营销奖专项金奖',
        },
        {
          img:require('../../assets/img/index/202216.jpg'),
          title:'年度母婴TP服务商杰出表现大奖',
        },
        {
          img:require('../../assets/img/index/202215.jpg'),
          title:'2022年度TBI杰出品牌创新奖',
        },
        {
          img:require('../../assets/img/index/202201.jpg'),
          title:'京东美妆“最佳合作伙伴奖”',
        },
        {
          img:require('../../assets/img/index/202202.jpg'),
          title:'2022年·第4季度天猫星级服务商',
        },
        {
          img:require('../../assets/img/index/202204.jpg'),
          title:'2022年·第10届Topdigital创新营销奖',
        },
        {
          img:require('../../assets/img/index/202205.jpg'),
          title:'2022年·第22届IAI传鉴国际广告奖',
        },
        {
          img:require('../../assets/img/index/202206.jpg'),
          title:'2022年·京赢未来效果营销赛道金奖',
        },
        {
          img:require('../../assets/img/index/202207.jpg'),
          title:'2022 M awards年度货品经营｜优胜奖',
        },
        {
          img:require('../../assets/img/index/202208.jpg'),
          title:'京东代运营服务年度奖项·“京卓越”奖',
        },
        {
          img:require('../../assets/img/index/202209.jpg'),
          title:'天猫国际金星服务商',
        },
        {
          img:require('../../assets/img/index/202210.jpg'),
          title:'第8届TMA移动营销大奖',
        },
        {
          img:require('../../assets/img/index/202212.jpg'),
          title:'第八届蒲公英盛典·一金二银',
        },
        {
          img:require('../../assets/img/index/202213.jpg'),
          title:'第十四届“金投赏”商业创意奖',
        },
        {
          img:require('../../assets/img/index/202214.jpg'),
          title:'数聚智连喜获第十五届金投赏三个奖项',
        },
      //   {
      //     img:require('../../assets/img/index/13.jpg'),
      //     title:'母婴行业第一名',
      //   },
      //   {
      //     img:require('../../assets/img/index/11.jpg'),
      //     title:'五芳斋“与粽不同”天猫超级品牌日',
      //     s:'天猫服务商优秀案例',
      //   },
      //   {
      //     img:require('../../assets/img/index/12.jpg'),
      //     title:'西铁城时光开黑局',
      //     s:'第十一届金网奖时尚行业类别金奖<br/>天猫服务商优秀案例',
      //   },
      //   {
      //     img:require('../../assets/img/index/1.jpg'),
      //     title:'Oral-B星际洁齿',
      //     s:'第11届金投赏国际创意节金投赏奖；第25届中国国际广告节媒介营销金奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/2.jpg'),
      //     title:'舒肤佳 舒服家',
      //     s:'艾菲奖金奖、中国广告长城奖金奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/3.jpg'),
      //     title:'方便面3.0：方便不随便',
      //     s:'第11届金投赏国际创意节 金投赏奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/4.jpg'),
      //     title:'京东空气餐厅',
      //     s:'第25届中国国际广告节互动创意奖、媒介营销奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/5.jpg'),
      //     title:'牙不白，怎么红',
      //     s:'第25届中国国际广告节互动创意奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/6.jpg'),
      //     title:'放粽吧宝贝',
      //     s:'第25届中国国际广告节媒介营销奖',
      //   },
      // // ],
      // // con32KP2:[
      //   {
      //     img:require('../../assets/img/index/9.jpg'),
      //     title:'Tampax Launch Campaign',
      //   },
      //   {
      //     img:require('../../assets/img/index/10.jpg'),
      //     title:'Movefree天猫超级品牌日',
      //   },
      //   {
      //     img:require('../../assets/img/index/8.jpg'),
      //     title:'Oral-B发现新星图',
      //   },
      //   {
      //     img:require('../../assets/img/index/7.jpg'),
      //     title:'iBrush Plus黑科技邀请函',
      //   },
      ]
    }
  },
  methods: {
    names(data) {
      console.log(data)
    },
    ImgMouse(data){
      this.ImgHover = data;
    }
  },
  mounted(){
    var swiper2 = this.$refs.mySwipe1r2.swiper
    var insuranceCon2 = document.getElementById('insuranceCon2')
    var insuranceCon1 = document.getElementById('insuranceCon1')
    var insuranceCon3 = document.getElementById('insuranceCon3')
    var zhutijieshao = document.getElementById('zhutijieshao')
    var insuranceCon2Top = 0;//距离顶部位置
    var insuranceCon1Top = 0;//距离顶部位置
    var insuranceCon3Top = 0;//距离顶部位置
    var zhutijieshaoTop = 0;//距离顶部位置
    var that = this;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      //滚动条到底部的条件
      console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight+'元素距离顶部'+insuranceCon2.offsetTop);
      console.log("距顶部"+scrollHeight/windowHeight);

      function IsPC() {
          var userAgentInfo = navigator.userAgent;
          var Agents = ["Android", "iPhone",
                      "SymbianOS", "Windows Phone",
                      "iPad", "iPod"];
          var flag = true;
          for (var v = 0; v < Agents.length; v++) {
              if (userAgentInfo.indexOf(Agents[v]) > 0) {
                  flag = false;
                  break;
              }
          }
          return flag;
      }


      // if(scrollHeight/windowHeight<1.5){//如果宽高比不合适就不动画了
      if(!IsPC()){//如果宽高比不合适就不动画了
        that.Con1 = 6;
        that.Con2 = 6;
        that.Con3 = 4;
        that.Con4 = 4;
        swiper2.autoplay.start();//开始播放
      }else{
        window.onscroll = function(){
          //变量scrollTop是滚动条滚动时，距离顶部的距离
          var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
          //变量windowHeight是可视区的高度
          var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
          //变量scrollHeight是滚动条的总高度
          var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
          //滚动条到底部的条件
          console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight+'元素距离顶部'+insuranceCon2.offsetTop);
          
          if(scrollTop>=1700){
              swiper2.autoplay.start()
          }
          insuranceCon2Top = insuranceCon2.offsetTop-scrollTop;
          if(insuranceCon2Top<700 && insuranceCon2Top>600){
            that.Con2 = 1;
          }
          else if(insuranceCon2Top<=600 && insuranceCon2Top>500){
            that.Con2 = 2;
          }
          else if(insuranceCon2Top<=500 && insuranceCon2Top>400){
            // that.Con2 = 42.81;
            that.Con2 = 3;
          }
          else if(insuranceCon2Top<=400 && insuranceCon2Top>300){
            // that.Con2 = 42.81;
            that.Con2 = 4;
          }
          else if(insuranceCon2Top<=300 && insuranceCon2Top>200){
            // that.Con2 = 42.81;
            that.Con2 = 5;
          }
          else if(insuranceCon2Top<=200 && insuranceCon2Top>100){
            // that.Con2 = 42.81;
            that.Con2 = 6;
          }
          else if(insuranceCon2Top<=100){
            that.Con2 = 7;
          }
          else{
            that.Con2 = 0;
          }
          
          insuranceCon1Top = insuranceCon1.offsetTop-scrollTop;
          if(insuranceCon1Top<400 && insuranceCon1Top>300){
            that.Con1 = 1;
          }
          else if(insuranceCon1Top<=300 && insuranceCon1Top>200){
            that.Con1 = 2;
          }
          else if(insuranceCon1Top<=200 && insuranceCon1Top>100){
            that.Con1 = 3;
          }
          else if(insuranceCon1Top<=100 && insuranceCon1Top>0){
            that.Con1 = 4;
          }
          else if(insuranceCon1Top<=0){
            that.Con1 = 5;
          }else{
            that.Con1 = 0;
          }
          
          insuranceCon3Top = insuranceCon3.offsetTop-scrollTop;
          console.log(that.Con3,'that.Con3');
          if(insuranceCon3Top<650 && insuranceCon3Top>500){
            that.Con3 = 1;
          }
          else if(insuranceCon3Top<=500 && insuranceCon3Top>350){
            that.Con3 = 2;
          }
          else if(insuranceCon3Top<=350 && insuranceCon3Top>250){
            that.Con3 = 3;
          }
          else if(insuranceCon3Top<=250){
            that.Con3 = 4;
          }
          else{
            that.Con3 = 0;
          }
          zhutijieshaoTop = zhutijieshao.offsetTop-scrollTop;
          console.log(that.Con4,'that.Con4');
          if(zhutijieshaoTop<550 && zhutijieshaoTop>500){
            that.Con4 = 1;
          }
          else if(zhutijieshaoTop<=500 && zhutijieshaoTop>350){
            that.Con4 = 2;
          }
          else if(zhutijieshaoTop<=350 && zhutijieshaoTop>250){
            that.Con4 = 3;
          }
          else if(zhutijieshaoTop<=250){
            that.Con4 = 4;
          }
          else{
            that.Con4 = 0;
          }
          
        }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.insurance{
  svg{
    width:60%;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  path,rect {
      stroke-dasharray: 140;
      stroke-dashoffset: 0;
      /* animation: dash 3s linear infinite; */
      animation: dash 1.5s linear 1;
      animation-fill-mode: forwards;
      /* 填充的透明度 */
      fill-opacity:0;
      /* 描边宽度 */
      stroke-width:0.7;
      /* 描边画笔是圆头 */
      stroke-linecap:'round';
      /* 描边画笔拐角是圆头 */
      stroke-linejoin:'round';
  }
  @keyframes dash {
      0% {
          stroke-dashoffset: 140;
      }
      30% {
          fill-opacity:0;
          stroke-width:0.7;
      }
      100% {
          stroke-dashoffset: 0;
          stroke-width:0.0;
          fill-opacity:1;
      }
  }
  .buged{
    border-top: 1px solid transparent;
    position: relative;
  }
  .luoBI{
    display: inline-block;
    width: 350px;
    height: 300px;
    overflow: hidden;
    margin:0 10px;
    img{
      width: 100%;
    }
    span{
      font-size: 16px;
      display: block;
      line-height: 50px;
      text-align: center;
      color: #666;
    }
  }
  .ceshi{
    display: inline-block;
    width: 7rem;
    height: 3rem;
  }
  .swiperImg{
    width: 100%;
    min-width: 1200px;
    height: auto;
  }
  // 第一屏
  .insuranceCon1{
    .insuranceCon12{
      height: 580px;
      margin-bottom: 80px;
    }
    // .insuranceCon12>.insuranceCon12To:hover .insuranceCon12Zhe{
    //   opacity: 1;
    // }
    .insuranceCon12>.insuranceCon12To{
      display: inline-block;
      font-size: 0;
      overflow: hidden;
      height: 290px;
      width: 25%;
      float: left;
      position: relative;
      img{
        display: block;
        margin: 0;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        position: absolute;
        left: 0;
        top:0;
        z-index: 1;
      }
      .insuranceCon12Zhe{
        display: inline-block;
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        left: 0;
        top:0;
        background: rgba(0,104,183,0.8);
        z-index: 2;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        span{
          display: inline-block;
          width: 80px;
          height: 80px;
          background: url('../../assets/img/index/add.png') no-repeat center;
          background-size: cover;
          position: absolute;
          top: 20px;
          left: 20px;
          transition: all 1s ease-out;
          -moz-transition: all 1s ease-out;	/* Firefox 4 */
          -webkit-transition: all 1s ease-out;	/* Safari 和 Chrome */
          -o-transition: all 1s ease-out;	/* Opera */
        }
        img{
          position: absolute;
          top:0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 50%;
        }
      }
    }
    .ImgBig{
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
    }
    .ImgMix{
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
    }
    .insuranceCon12>div:nth-of-type(1){
      width: 50%;
    }
    .insuranceCon12>div:nth-of-type(5){
      width: 50%;
    }
    .insuranceCon11{
      height: 300px;
      background: #fff;
      .insuranceCon11_right,.insuranceCon11_left{
        display: inline-block;
        height: 100%;
        width: 50%;
        float: left;
        border: none;
        // display: flex;
      }
    }
    .insuranceCon11::after{
      display: inline-block;
      overflow: hidden;
      clear: both;
      content: '';
    }
    .insuranceCon11_left{
      position: relative;
      img{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        width: 20%;
        animation: insuran11SF 5s;
        -moz-animation: insuran11SF 5s;	/* Firefox */
        -webkit-animation: insuran11SF 5s;	/* Safari 和 Chrome */
        -o-animation: insuran11SF 5s;	/* Opera */
      }
      @keyframes insuran11SF
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-moz-keyframes insuran11SF /* Firefox */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-webkit-keyframes insuran11SF /* Safari 和 Chrome */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-o-keyframes insuran11SF /* Opera */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }
      .insuranceAbout{
        display: inline-block;
        width: 190px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 38px;
        color: #555;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        animation: swiperRc 3s;
        -moz-animation: swiperRc 3s;	/* Firefox */
        -webkit-animation: swiperRc 3s;	/* Safari 和 Chrome */
        -o-animation: swiperRc 3s;	/* Opera */
        .insuranceAbout_top{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .insuranceAbout_bot{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/index/right.png') no-repeat right;
          font-weight: 900;
        }
      }
    }
    .insuranceCon11_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      padding:50px 20px;
      box-sizing: border-box;
    }
    .insuranceCon11_right>span{
      position: absolute;
      left: 0;
      top: 70px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    .insuranceCon11::after{
      content: '';
      clear: both;
    }
  }
  .swiper-container{//轮播入场
    animation: swiperRc 2s;
    -moz-animation: swiperRc 2s;	/* Firefox */
    -webkit-animation: swiperRc 2s;	/* Safari 和 Chrome */
    -o-animation: swiperRc 2s;	/* Opera */
  }
  @keyframes swiperRc
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-moz-keyframes swiperRc /* Firefox */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-webkit-keyframes swiperRc /* Safari 和 Chrome */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-o-keyframes swiperRc /* Opera */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }
  //第二屏
  .insuranceCon2{
    height: 600px;
    background: url('../../assets/img/index/indexBG.jpg') no-repeat center;
    min-width: 1200px;
    transition: all 2s;
    -moz-transition: all 2s;	/* Firefox 4 */
    -webkit-transition: all 2s;	/* Safari 和 Chrome */
    -o-transition: all 2s;	/* Opera */
    .insuranceCon21{
      height: 100%;
      position: relative;
      .insuranceH1{
        display: inline-block;
        width: 190px;
        position: absolute;
        top: 30px;
        left: 0;
        right: 0;
        margin: auto;
        font-size: 38px;
        color: #555;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        .InsHistory1{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .InsHistory2{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/index/down.png') no-repeat right;
          margin-bottom: 50px;
          font-weight: 900;
        }
        .InsHistory3{
          display: inline-block;
          height: 4px;
          width: 40px;
          background: #0168b7;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
      .insuranceSJZ{
        position: absolute;
        height: 220px;
        left: 0;
        right: 0;
        bottom: 10px;
        margin: auto;
        .insuranceLine{
          position: absolute;
          left: 0;
          // width: 100%;
          height: 1px;
          background: #ccc;
          top:5px;
          transition: all 0.6s;
          -moz-transition: all 0.6s;	/* Firefox 4 */
          -webkit-transition: all 0.6s;	/* Safari 和 Chrome */
          -o-transition: all 0.6s;	/* Opera */
        }
        .insuranceDot{
          display: inline-block;
          opacity: 1;
          width: 10px;
          height: 10px;
          position: absolute;
          transition: all 0.6s;
          -moz-transition: all 0.6s;	/* Firefox 4 */
          -webkit-transition: all 0.6s;	/* Safari 和 Chrome */
          -o-transition: all 0.6s;	/* Opera */
        }
        .insuranceDot::after{
          content: '';
          display: inline-block;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.2);
          border-radius: 50%;
        }
        .insuranceDot::before{
          content: '';
          display: inline-block;
          position: absolute;
          width: 60%;
          height: 60%;
          background: #555;
          border-radius: 50%;
          top: 20%;
          left: 20%;
        }
        .insuranceTitle{
          .InsuTitle{
            font-size: 28px;
            color: rgba(0,0,0,0.2);
            font-weight: 900;
            font-style:oblique;
            width: 100px;
            display: inline-block;
          }
          .InsuCon{
            color: #999;
          }
          h2{
            font-size: 14px;
            margin: 0;
            color: #828282;
          }
          display: inline-block;
          height: 0px;
          position: absolute;
          font-size: 12px;
          overflow: hidden;
          transition: all 1s;
          -moz-transition: all 1s;	/* Firefox 4 */
          -webkit-transition: all 1s;	/* Safari 和 Chrome */
          -o-transition: all 1s;	/* Opera */

        }
      }
    }
    /* for Chrome */
    .insuranceCon21::-webkit-scrollbar {
        display: none;
    }
  }
  // 第三屏
  .insuranceCon3{
    height: 500px;
    .insuranceCon31{
      position: relative;
      .receivingPrizes{
        display: inline-block;
        width: 350px;
        position: absolute;
        top: 30px;
        left: 0;
        right: 0;
        margin: auto;
        font-size: 38px;
        color: #555;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        text-align: center;
        .receivingPrizes1{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .receivingPrizes2{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/index/down.png') no-repeat 240px;
          margin-bottom: 50px;
          font-weight: 900;
        }
        .receivingPrizes3{
          display: inline-block;
          height: 4px;
          width: 40px;
          background: #0168b7;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
    .insuranceCon32{
      height: 200px;
      position: absolute;
      top: 230px;
      left: 0;
      right: 0;
      margin: auto;
      .con32KP{
        padding: 30px;
        box-sizing: border-box;
        font-size: 12px;
        display: inline-block;
        background: #fff;
        width: 400px;
        height: 540px;
        box-shadow: 0px 0px 40px rgba(0,0,0,0.2);
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        position: absolute;
      }
      .con32KP>div{
        margin-bottom: 30px;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
      }
      .con32KP>div>span:nth-of-type(1){
        font-size: 16px;
        color: #555;
        line-height: 40px;
      }
      .con32KP>div>span:nth-of-type(2){
        font-size: 14px;
        color: #828282;
        margin-bottom: 20px;
      }
    }
  }
  .ZhuanY{
    transform:rotate(0deg);
    -ms-transform:rotate(0deg); 	/* IE 9 */
    -moz-transform:rotate(0deg); 	/* Firefox */
    -webkit-transform:rotate(0deg); /* Safari 和 Chrome */
    -o-transform:rotate(0deg); 	/* Opera */
  }
  .ZhuanN{
    transform:rotate(360deg);
    -ms-transform:rotate(360deg); 	/* IE 9 */
    -moz-transform:rotate(360deg); 	/* Firefox */
    -webkit-transform:rotate(360deg); /* Safari 和 Chrome */
    -o-transform:rotate(360deg); 	/* Opera */
    }



    
  // 公司主题介绍
  .zhutijieshao{
    height: 550px;
    position: relative;
    .receivingPrizes{
      display: inline-block;
      width: 350px;
      position: absolute;
      top: 30px;
      left: 0;
      right: 0;
      margin: auto;
      font-size: 38px;
      color: #555;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      text-align: center;
      .receivingPrizes1{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        font-weight: 900;
      }
      .receivingPrizes2{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/index/down.png') no-repeat 260px;
        margin-bottom: 50px;
        font-weight: 900;
      }
      .receivingPrizes3{
        display: inline-block;
        height: 4px;
        width: 40px;
        background: #0168b7;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    .zhutiSend{
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      position: absolute;
      top: 200px;
    }
    .zhutiSend>div{
      text-align: center;
      margin: 0px 20px;
      // box-shadow: #ccc 0px 0px 10px;
      padding: 30px;
      width: 30%;
      display: flex;
      flex-direction: column;
        justify-content: center;
        align-items: center;
      h3{
        font-size: 16px;
        color: #666;
        display: inline-block;
        // text-align: left;
        width: 25%;
        position: relative;
        border-bottom: #0168b7 1px solid;
      }
      // h3:after{
      //   content: '';
      //   background: #0168b7;
      //   display: inline-block;
      //   height: 1px;
      //   width: 70px;
      //   position: absolute;
      //   bottom: -4px;
      //   left: 70px;
      // }
      span{
        display: inline-block;
        height: 200px;
        width: 100%;
        font-size: 12px;
        color: rgb(130, 130, 130);
        text-align: left;
      }
      img{
        width:200px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/insurance.vue